import theme from '../themes/default'

export default {
  wrap: {
    'margin-bottom': '60px',
    '& .am-activity-indicator': {
      background: '#fff',
      position: 'absolute',
      padding: '8px 5px',
      borderRadius: '5px',
      width: '42px',
      margin: '20% auto 0',
      left: '0',
      right: '0',
      'text-align': 'center',
    },
    '& .am-activity-indicator-spinner': {
      margin: '0 auto',
    },
  },
  'wrap-sticky': {
    // 'padding-top': '70px'
  },
  'with-subcate-backgroud-image': {
    'min-height': '95px',
    'margin-bottom': '-25px',
  },
  'with-subcate-background-image-padding': {
    // 'padding-top': '50px',
  },
  'default-backgroud-image': {
    'min-height': '50px',
  },
  'without-background-image': {
    'min-height': '15px',
  },
  'checkout-container': {
    'margin-bottom': '0px',
  },
  'item-cover-image-modal': {
    width: '90% !important',
  },
  'app-promo-modal': {
    width: '90% !important',
    maxWidth: '400px',
    '& > div': {
      background: 'transparent',
    },
  },
  'close-btn': {
    position: 'absolute',
    top: '10px',
    right: '15px',
    background: 'white',
    width: '20px',
    height: '20px',
    'box-shadow': '0 0 8px 0px rgb(0 0 0 / 20%)',
    'border-radius': '50%',
    'line-height': '120%',
    'text-align': 'center',
    cursor: 'pointer',
  },
  'app-promo-img': {
    cursor: 'pointer',
    'box-shadow': '0 0 8px rgb(0 0 0 / 20%)',
  },
  'subcategory-margin-buffer': {
    'margin-top': '50px',
  },
  'subcategory-margin-without-buffer': {
    'margin-top': '0',
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/CategoryDetail.js